import { useCallback, useContext, useEffect, useState } from "react";

import { Button, Input, Modal, MultiSelect, Switch } from "../../../BP2Components";
import { FormBuilderContext } from "../FormBuilderContext";

import CreateNewListModal from "../../ListBuilder/ListBuilderView/ListBuilderModals/CreateNewListModal";
import IntlMessages from "../../../../util/IntlMessages";
import BusinessMethodsModal from "./BusinessMethodsModal";

import { getFormModels } from "services/restAPI/FormsV3";

import "./FormSettings.less";

const INITIAL_FORM_STATE = {
   name: "",
   formSelected: null,
   id: null,
};

const FormSettings = ({ setIsModalOpen, isModalOpen }) => {
   const [selected, setSelected] = useState(null);
   const [formName, setFormName] = useState("");
   const [isMethodsModalOpen, setIsMethodsModalOpen] = useState(false);
   const [draftBusinessMethods, setDraftBusinessMethods] = useState([]);

   const {
      previewMode,
      setPrevieMode,
      submitForm,
      setData,
      selectedForm,
      setSelectedForm,
      data,
      setEditedForm,
      setListItems,
      setTabs,
      setTabsItems,
      setActiveTabId,
      businessMethods,
      showSaveButton,
      setShowSaveButton,
      submitFormMethods,
      setMethods,
   } = useContext(FormBuilderContext);

   const resetCreateFormState = () => {
      setFormName("");
      setSelected(null);
      setSelectedForm(null);
      setEditedForm(null);
      setListItems([]);
      setTabs([]);
      setTabsItems({});
      setActiveTabId(null);
      setDraftBusinessMethods([]);
      setShowSaveButton(true);
      setData({ type: "change", value: INITIAL_FORM_STATE });
   };

   const showModal = () => {
      setIsModalOpen(true);
      resetCreateFormState();
   };

   const handleOk = () => {
      setMethods([]);
      setIsModalOpen(false);
      setSelectedForm(selected);
      setData({
         type: "change",
         value: {
            name: formName,
            formSelected: selected,
         },
      });
   };

   const handleCancel = () => {
      setIsModalOpen(false);
   };

   const [models, setModels] = useState([]);

   const fetchModels = async () => {
      const res = await getFormModels();

      if (res?.status === 200) {
         const mappedModels = res.data?.map((model) => {
            const [module, name] = model.split(".");
            return { label: name, module, value: `${module}-${name}` };
         });

         setModels(mappedModels);
      }
   };

   useEffect(() => {
      fetchModels();
   }, []);

   useEffect(() => {
      if (!data?.formSelected) return;
      setFormName(data?.name || "");
      const raw = typeof data.formSelected.value === "string" ? data.formSelected.value : "";
      if (!raw) return;
      const [module, name] = raw.split("-");
      setSelected({ label: name, module, value: `${module}-${name}` });
   }, [data]);

   const [isOpen, setIsOpen] = useState();

   const handleCreateNewList = useCallback(() => {
      setIsOpen(true);
   }, [data?.id]);

   return (
      <>
         <div className="form-builder-settings">
            <div className="form-builder-settings-left">
               <Button buttonType="primary" onClick={showModal}>
                  + {<IntlMessages id="modal.createNewForm" />}
               </Button>

               {data?.id && (
                  <Button onClick={handleCreateNewList} buttonType="primary">
                     +&nbsp;
                     <IntlMessages id="listBuilder.create-new-list-in-form" />
                  </Button>
               )}
            </div>

            {selectedForm && (
               <div className="form-builder-settings-right">
                  <div className="form-builder-settings-mode">
                     <Switch defaultChecked={previewMode} onChange={(e) => setPrevieMode(e)} />
                     <IntlMessages id="form.formPreview" />
                  </div>

                  <div className="form-builder-settings-mode">
                     <Switch
                        checked={showSaveButton}
                        onChange={(value) => setShowSaveButton(value)}
                     />
                     <IntlMessages id="form.showSaveButton" defaultMessage="Przycisk Zapisz" />
                  </div>

                  {data?.id && (
                     <Button
                        onClick={() => {
                           setDraftBusinessMethods(businessMethods);
                           setIsMethodsModalOpen(true);
                        }}
                     >
                        <IntlMessages id="form.businessMethods" defaultMessage="Metody biznesowe" />
                     </Button>
                  )}

                  <Button buttonType="primary" onClick={submitForm}>
                     {<IntlMessages id="form.saveForm" />}
                  </Button>
               </div>
            )}

            <Modal isOpen={isModalOpen} onOk={handleOk} onCancel={handleCancel} height={500}>
               <div className="form-builder-settings-modal">
                  <div>
                     <label>{<IntlMessages id="form.selectFormName" />}</label>
                     <Input
                        onChange={(e) => setFormName(e.target.value)}
                        value={formName ?? data.name}
                     />
                  </div>
                  <div>
                     <label>{<IntlMessages id="form.selectFormModule" />}</label>
                     <MultiSelect
                        options={models}
                        isMulti={false}
                        closeMenuOnSelect
                        value={selected ?? data.formSelected}
                        onChange={(option) => setSelected(option)}
                        isCreatable={false}
                     />
                  </div>
               </div>
            </Modal>
         </div>

         <BusinessMethodsModal
            isOpen={isMethodsModalOpen}
            onClose={() => setIsMethodsModalOpen(false)}
            businessMethods={draftBusinessMethods}
            savedBusinessMethods={businessMethods}
            onChange={setDraftBusinessMethods}
            onSave={() => submitFormMethods(draftBusinessMethods)}
         />

         <CreateNewListModal parentFormId={data?.id} isOpen={isOpen} setIsOpen={setIsOpen} />
      </>
   );
};

export default FormSettings;
